export const ERROR_AUTH_LOGIN = 'ERROR_AUTH_LOGIN';
export const ERROR_UNEXPECTED = 'ERROR_UNEXPECTED';
export const ERROR_FORGOT_PASSWORD_VALIDATE = 'ERROR_FORGOT_PASSWORD_VALIDATE';
